<div class="wvSummary" [ngClass]="'summary' + moduleKey" [hidden]="slideError">
    <div class="row" *ngIf="summaryState?.SummaryTitle.trim() !== ''">
        <div class="mx-auto" [ngClass]="hasBackdrop ? 'wvCustomSummaryHeaderDark' : 'wvCustomSummaryHeaderLight'">
            <div class="font-size-32 align-content-center txtOverflow col-xl-12">{{summaryState?.SummaryTitle}}</div>
        </div>
    </div>

    <div class="mx-auto" [ngClass]="hasBackdrop ? 'wvCustomSummaryMetricDark' : 'wvCustomSummaryMetricLight'">
        <div class="row no-gutters">
            <div class="col-xl-12 d-flex summaryMetricHeaders justify-content-end">
                <div class="col-xl-3 font-size-24 customSummaryName">Name</div>
                <!--<div style="width: 40%; height: 1px; display: inline-block;"></div>-->
                <div class="col-xl-3" *ngIf="summaryMetricNames.length < 3"></div>
                <div class="col-xl-3" *ngIf="summaryMetricNames.length < 2"></div>
                <div class="summaryMetricName  txtOverflow col-xl-3 pr-0" *ngFor="let Name of summaryMetricNames">{{Name}}</div>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="customSummaryTableRow col-xl-12 font-size-24 d-flex border-bottom" *ngFor="let item of summaryData?.Summary_Module_Data_List; let i = index">
                <div class="summaryGroupName txtOverflow col-xl-3">
                    <div class="customSummaryRank" *ngIf="summaryState.ShowRank">{{i + 1}}</div>
                    {{item.groupName}}
                </div>

                <!--<div class="summaryMetricData custom" *ngFor="data in item.metricData">{{Data.MetricDisplayValue}}</div>-->
                <div class="col-xl-3" *ngIf="summaryMetricNames.length < 3"></div>
                <div class="col-xl-3" *ngIf="summaryMetricNames.length < 2"></div>
                <div class="summaryMetricData  col-xl-3 pr-0" *ngFor="let data of item.metricData">{{data.MetricDisplayValue}}</div>
            </div>
        </div>
    </div>
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
